import * as Yup from 'yup';
import i18n from 'i18next';
import { phoneRegExp, emailRegExp } from 'globalutils/constants';

export const schema = Yup.object().shape({
  firstName: Yup.string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .test('len', i18n.t('Please enter value between 2 and 30 characters'), (val) => val && val.length > 1 && val.length < 31),
  lastName: Yup.string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .test('len', i18n.t('Please enter value between 2 and 30 characters'), (val) => val && val.length > 1 && val.length < 31),
  email: Yup.string().matches(emailRegExp, i18n.t('common.emailValidationMessage')).required(i18n.t('common.fieldRequiredMessage')),
  userPhone: Yup.string().matches(phoneRegExp, i18n.t('common.validNumFormat')).required(i18n.t('common.fieldRequiredMessage')),
  password: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  confPassword: Yup.string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .oneOf([Yup.ref('password'), null], 'Passwords must match'),
});
